import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { UpdateAlertMutation, Alert } from '#/graphql/types';
import { updateAlert } from '#/graphql/mutations';
import { mutationFields } from '../utils/mutationDataFields';
import { getAlert } from '#/graphql/queries';

const q = gql(updateAlert);
const GET_ALERT = gql(getAlert);

const useAlertUpdate = () => {
  const [mutation, result] = useMutation<UpdateAlertMutation>(q);
  const updateAlert = useCallback(
    async (itemId: string, alert: Alert) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(alert, mutationFields),
        },
        refetchQueries: [{ query: GET_ALERT, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateAlert', undefined);
    },
    [mutation],
  );

  return { updateAlert, result };
};

export default useAlertUpdate;
